import React, { useEffect, useState } from "react";
import Header from '../../components/Header/Header';
import {useTranslation} from "react-i18next";
import './videoCallBusy.scss'

const VideoCallBusy = () => {
  const {t} = useTranslation();

  return (
    <>
      <Header />

      <div className="text-center mt-5">
        <img className="img-fluid mt-4" src={require('../../assets/images/logo.png')}/>
      </div>

      <div className="mx-auto text-center mt-5 px-4 pt-5">
        <h4 className="busy-video-text">{t('busyVideoCall1')}</h4>
        <h4 className="busy-video-text">{t('busyVideoCall2')}</h4>
        <h4 className="busy-video-text mt-3">{t('busyVideoCall3')}</h4>
      </div>
    </>
  );
};

export default VideoCallBusy;